export function formatDuration(seconds?: number | null): string {
  if (seconds === undefined || seconds === null) {
    return '-';
  }

  const totalSeconds = Math.floor(seconds);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;

  const parts: string[] = [];

  if (hours >= 1) {
    parts.push(`${Math.floor(hours)}${Math.floor(hours) === 1 ? 'hr' : 'hrs'}`);
  }

  if (minutes >= 1) {
    parts.push(`${Math.floor(minutes)}m`);
  }

  if (parts.length === 0) {
    const displaySeconds = Math.max(1, Math.floor(secs));
    parts.push(`${displaySeconds}s`);
  }

  return parts.join(' ');
}

const timeFormatter = new Intl.DateTimeFormat(undefined, {
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
});

const currentYearFormatter = new Intl.DateTimeFormat(undefined, {
  month: 'short',
  day: 'numeric',
});

const previousYearFormatter = new Intl.DateTimeFormat(undefined, {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
});

const formatTime = (date: Date) => timeFormatter.format(date);

const formatDateAtTime = (date: Date, includeYear: boolean) => {
  const dateText = includeYear
    ? previousYearFormatter.format(date)
    : currentYearFormatter.format(date);
  return `${dateText}, at ${formatTime(date)}`;
};

const startOfDay = (date: Date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

const isSameDay = (date: Date, other: Date) => {
  return startOfDay(date).getTime() === startOfDay(other).getTime();
};

const addDays = (date: Date, days: number) => {
  const next = new Date(date);
  next.setDate(next.getDate() + days);
  return next;
};

export function formatCalendarStyle(isoTimestamp?: string | null): string {
  if (isoTimestamp === undefined || isoTimestamp === null) {
    return '-';
  }

  const date = new Date(isoTimestamp);
  if (Number.isNaN(date.getTime())) {
    return '-';
  }

  const now = new Date();

  if (isSameDay(date, now)) {
    return `Today at ${formatTime(date)}`;
  }
  if (isSameDay(addDays(date, 1), now)) {
    return `Yesterday at ${formatTime(date)}`;
  }
  if (date.getFullYear() === now.getFullYear()) {
    return formatDateAtTime(date, false);
  }
  return formatDateAtTime(date, true);
}
